###

Connector information comes from two sources: for database connections (MySQL,
PSQL, MSSQl and MongoDB), we get status information from the ``connectionmeta/``
endpoint, and for all other connections, we can use the ``jobs/`` endpoint of
the API.

This service provides functionality for converting the responses from these
services into a common, simplified format for use on the Connections page.

###

angular.module('rjmNg.services').factory "connectionStatusTranslator", [
  "JOBS"
  "CONNECTIONS"
  "utils"
  (
    JOBS
    CONNECTIONS
    utils
  ) ->

    SIMPLIFIED_STATUS =
      SUCCESS: "success"
      AUTH_ERROR: "auth_error"
      IN_PROGRESS: "in_progress"
      ERROR: "error"
      PAUSED: "paused"

    DB_STATUS =
      ERROR: "FAIL"
      IN_PROGRESS: "Testing..."
      SUCCESS: "OK"
      USER_PAUSED: "Paused"
      SYSTEM_PAUSED: "System Paused"

    getSimplifiedStatusForJobStatus = (status) ->
      switch status
        when JOBS.STATUSES.AUTH_ERROR
          SIMPLIFIED_STATUS.AUTH_ERROR
        when JOBS.STATUSES.CONNECTOR_ERROR, JOBS.STATUSES.IAPI_ERROR
          SIMPLIFIED_STATUS.ERROR
        when JOBS.STATUSES.IN_PROGRESS
          SIMPLIFIED_STATUS.IN_PROGRESS
        when JOBS.STATUSES.INTERRUPTED
          SIMPLIFIED_STATUS.IN_PROGRESS
        when JOBS.STATUSES.PENDING_INTERRUPT
          SIMPLIFIED_STATUS.IN_PROGRESS
        when JOBS.STATUSES.SUCCESS or JOBS.STATUSES.COMPLETE
          SIMPLIFIED_STATUS.SUCCESS
        when JOBS.STATUSES.THIRD_PARTY_ERROR
          SIMPLIFIED_STATUS.ERROR

    _generateAdobeAnalyticsErrorMessage = (messageObj) ->
      metricsAndDimensions = messageObj.data.split(" ")
      metricsAndDimensionsPairs = utils.chunks(metricsAndDimensions)
      metricsAndDimensionsList = metricsAndDimensionsPairs.map(
        ([metric, dimension]) ->
          "#{metric} (metric) & #{dimension} (dimension)"
      ).join(", ")
      if messageObj.truncated is 1
        metricsAndDimensionsList += ", and others (Contact support to get the whole list of metrics and dimensions)"
      return "The following components returned an error during replication, \
        indicating a possible permissions issue with a metric and/or dimension: \
        #{metricsAndDimensionsList}. Please check that these components are \
        available to the user account in Adobe Analytics."

    _isJsonMessage = (message) ->
      if utils.isJsonObj(message)
        messageObj = JSON.parse(message)
        return messageObj.data? and messageObj.truncated?
      else
        return false

    getMessageForStatus = (thirdPartyStatus, status) ->
      if thirdPartyStatus is SIMPLIFIED_STATUS.AUTH_ERROR
        "Please verify that your credentials are up-to-date."
      else if thirdPartyStatus is SIMPLIFIED_STATUS.ERROR and
        status.type is CONNECTIONS.TYPES.ADOBE_ANALYTICS and
        _isJsonMessage(status.message)
          _generateAdobeAnalyticsErrorMessage(JSON.parse(status.message))
      else if thirdPartyStatus is SIMPLIFIED_STATUS.ERROR
        "The connection failed. We will re-attempt shortly."

    parseDateTime = (datetime) ->
      moment(datetime)

    dateTimeToString = (datetime) ->
      datetime.local().format("MMM D, YYYY, hh:mm A")

    translateThirdPartyConnectorStatus = (status) ->
      return unless status?

      thirdPartyStatus = getSimplifiedStatusForJobStatus(status.status)

      return unless thirdPartyStatus?

      startTime = parseDateTime(status.start_time)
      return unless status.start_time? and startTime.isValid()

      formattedTime =
        start: dateTimeToString(startTime)
        offset: startTime.fromNow()

      endTime = parseDateTime(status.end_time)
      if status.end_time? and endTime.isValid()
        duration = moment.duration(endTime - startTime)

        formattedTime.end = dateTimeToString(endTime)
        formattedTime.duration = duration.humanize()

      status: thirdPartyStatus
      message: getMessageForStatus(thirdPartyStatus, status)
      formattedTime: formattedTime

    getSimplifiedStatusForDBStatus = (status) ->
      switch status
        when DB_STATUS.ERROR
          SIMPLIFIED_STATUS.ERROR
        when DB_STATUS.IN_PROGRESS
          SIMPLIFIED_STATUS.IN_PROGRESS
        when DB_STATUS.USER_PAUSED, DB_STATUS.SYSTEM_PAUSED
          SIMPLIFIED_STATUS.PAUSED
        when DB_STATUS.SUCCESS
          SIMPLIFIED_STATUS.SUCCESS

    translateDBConnectorStatus = (status) ->
      return unless status?

      dbStatus = getSimplifiedStatusForDBStatus(status.status)
      statusObj = {}
      if dbStatus?
        statusObj = {
          status: dbStatus
          formattedTime:
            offset: status.lastConnectionAttempt
        }
        if dbStatus is SIMPLIFIED_STATUS.ERROR
          statusObj.message = "Could not connect to database"

      statusObj

    {
      translateThirdPartyConnectorStatus
      translateDBConnectorStatus
      SIMPLIFIED_STATUS
    }

]
